<template>
    <div :class="conClass">
        <i class="iconfont uc-guanbi" @click="onClose"></i>
        <mt-index-list ref="indexList">
            <mt-index-section index="热">
              <div class="hot-brands">
                <div class="brand" v-for="item in hotBrands" :key="'s' + item.id" @click="onConfirmItem(item)">
                  <div class="logo">
                    <img :src="item.img" class="h-logo"/>
                  </div>
                  <div class="txt">{{item.name.substr(0,2)}}</div>
                </div>
              </div>
            </mt-index-section>
            <mt-index-section v-for="(list, bd) in brandsList" :index="bd" :key="'i-' + bd">
                <li v-for="item in list" :title="item.name" :key="item.id" class="brand" @click="onConfirmItem(item)">
                    <div class="img"><img :src="item.img" class="bicon"/></div>
                    <div class="name">{{item.name}}</div>
                </li>
            </mt-index-section>
        </mt-index-list>
    </div>
</template>

<script>
import { IndexList, IndexSection } from 'mint-ui'
import { deepClone } from '../../utils'
const brandsList = require('../../configs/carBrands')
export default {
  components: {
      [IndexList.name]: IndexList,
      [IndexSection.name]: IndexSection
  },
  props: {
      openBrandBox: {
          type: Boolean,
          default: false
      }
  },
  filters: {

  },
  data() {
    return {
        conClass: 'brands',
        winHeight: window.outerHeight,
        brandsList,
        hotBrands: []
    };
  },
  watch: {
      openBrandBox(open){
        this.conClass = open ? 'brands opened' : 'brands dismiss'
        // if(!open){
        //   this.$nextTick(()=>{
        //     this.conClass = 'brands'
        //   })
        // }
      }
  },
  computed: {
  },
  methods: {
      onClose(){
          this.$emit('onClosed')
      },
      onConfirmItem(item){
          this.$emit('onSelected', item)
      }
  },
  beforeCreate() {},
  created() {
  },
  mounted() {
    const brandObj = deepClone(this.brandsList)
    Object.keys(brandObj).forEach(key => {
      this.hotBrands = this.hotBrands.concat(brandObj[key].filter(item => item.isHot))
    })
    this.$nextTick(()=>{
      if(this.$refs.indexList){
        this.$refs.indexList.$el.querySelector(".mint-indexsection-index").innerText = '热门品牌'
      }
    })
  },
  destroyed(){
    
  }
};
</script>
<style lang="scss" scoped>
.opened {
  animation: slide-in 0.2s forwards;
}

.dismiss {
  animation: slide-out 0.2s forwards;
}
@keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
@keyframes slide-out {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
}
.hot-brands{
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  .brand{
    width: .8rem;
    display: flex;
    flex-direction: column;
    .logo{
      width: 100%;
      text-align: center;
      padding: .1rem 0rem;
        .h-logo{
          max-width: .8rem;
          max-height: .8rem;
        }
    }
    .txt{
      font-size: .23rem;
      color:#666;
      padding: .2rem 0rem;
    }
  }
}
.brands{
    position: fixed;
    background: #fff;
    width: 100%;
    height: 100%;
    left: 0rem;
    top: 0rem;
    overflow: hidden;
    transform: translateX(100%);
    z-index: 10;
    .brand{
        display: flex;
        align-items: center;
        margin: 0rem .3rem;
        border-bottom: solid 1px #f4f4f4;
        .img{
            width: 1rem;
            padding:.1rem 0rem;
            .bicon{
                max-width: .8rem;
                max-height: .8rem;
                color: #333;
            }
        }
        .name{
            flex: 1;
        }
    }
    .brand:last-child{
        border: none;
    }
    .uc-guanbi{
        position: absolute;
        right: .1rem;
        top: .1rem;
        z-index: 3;
        text-align: center;
        line-height: .4rem;
        width:.4rem;
        height:.4rem;
        background:#bbb;
        border-radius: 50%;
        color: #fff;
        font-size: .23rem;
    }
}
.showWin{
    height: 100%;
}

</style>